import classNames from "classnames";
import ToolTip from "components/design/toolTip";
import { CALENDAR_YEAR_SHORT } from "constants/taxYear";
import { TaxYearPeriod } from "util/getTaxYearPeriod";

type TaxYearChipProps = {
  taxYear: TaxYearPeriod;
};

export const TaxYearChip = ({ taxYear }: TaxYearChipProps) => {
  const isCalendarYear = taxYear.shortLabel === CALENDAR_YEAR_SHORT;

  return (
    <ToolTip text={taxYear.periodLabel}>
      <span
        className={classNames(
          "t-shrink-0 t-rounded-sm t-border t-border-solid t-bg-white t-px-1 t-text-caption t-font-medium t-leading-none",
          {
            "t-border-neutral-10 t-text-neutral-50": isCalendarYear,
            "t-border-purple-20 t-text-purple-40": !isCalendarYear,
          }
        )}
      >
        {taxYear.shortLabel}
      </span>
    </ToolTip>
  );
};
